

export default class MissingECRImageError extends Error {
  constructor(message) {
    super(message)
    this.name = 'MissingECRImageError'
  }
}
